// @flow
import React from 'react';

type Props = {
    iconColor: string,
};

export default (props: Props) => (
    <svg
        style={{
            left: '44%',
            height: '57px',
            position: 'relative',
        }}
        className="spinner"
        viewBox="0 0 66 66"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            className="path"
            fill="none"
            strokeWidth="6"
            strokeLinecap="round"
            cx="33"
            cy="33"
            r="30"
            stroke={props.iconColor}
        />
    </svg>
);



// WEBPACK FOOTER //
// ./src/ui/components/Loader/index.js